import React, { useState, useRef, useEffect } from "react";
import "./css/AuthSign.css";
import SS from "./images/login/ss_Logo.png";
import Authsign from "./images/login/auth.png";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AuthSign() {
	const api_base_url = process.env.REACT_APP_API_BASE_URL;

	const navigate = useNavigate(null);
	const [loading, setLoading] = useState(false);

	const location = useLocation();
	const data = location.state || "";
	const [countdownInterval, setCountdownInterval] = useState(null);
	const [otpGenerated, setOtpGenerated] = useState({
		otp: data.otp,
	});

	const generateOTP = () => {
		return Math.floor(100000 + Math.random() * 900000);
	};

	const [countdown, setCountdown] = useState(600);

	// const handleCountdownIntervals = () => {
	// 	const countdownInterval = setInterval(() => {
	// 		setCountdown((prevCountdown) => {
	// 			if (prevCountdown <= 1) {
	// 				clearInterval(countdownInterval);
	// 				otpGenerated.otp = generateOTP();
	// 				return 0;
	// 			}
	// 			return prevCountdown - 1;
	// 		});
	// 	}, 1000);

	// 	return () => clearInterval(countdownInterval);
	// };

	const startCountdown = (initialTime) => {
		if (countdownInterval) {
			clearInterval(countdownInterval);
		}

		setCountdown(initialTime);

		const interval = setInterval(() => {
			setCountdown((prevCountdown) => {
				if (prevCountdown <= 1) {
					clearInterval(interval);
					setCountdownInterval(null);
					otpGenerated.otp = generateOTP();
					return 0;
				}
				return prevCountdown - 1;
			});
		}, 1000);

		setCountdownInterval(interval);
	};

	// useEffect(() => {
	// 	if (data.otp) {
	// 		handleCountdownIntervals();
	// 	}
	// }, [data]);

	useEffect(() => {
		if (data.otp) {
			startCountdown(600); // 10 minutes
		}

		// Cleanup on unmount**
		return () => {
			if (countdownInterval) {
				clearInterval(countdownInterval);
			}
		};
	}, [data]);

	// const handleGenerateOtp = async () => {
	// 	setValue({
	// 		a: "",
	// 		b: "",
	// 		c: "",
	// 		d: "",
	// 		e: "",
	// 		f: "",
	// 	});
	// 	otpGenerated.otp = generateOTP();

	// 	try {
	// 		const response = await fetch(`${api_base_url}/send`, {
	// 			method: "POST",
	// 			headers: {
	// 				"Content-Type": "application/json",
	// 			},
	// 			body: JSON.stringify({ ...data, otp: otpGenerated.otp }),
	// 		});
	// 		toast.dismiss();
	// 		if (response.ok) {
	// 			toast.success("OTP successfully sent to ********55", {
	// 				className: "custom-toast",
	// 				bodyClassName: "custom-toast-container",
	// 				closeButtonClassName: "custom-toast-close-button",
	// 				onClose: () => { },
	// 			});
	// 			setCountdown(60);
	// 			const countdownInterval = setInterval(() => {
	// 				setCountdown((prevCountdown) => {
	// 					if (prevCountdown <= 1) {
	// 						clearInterval(countdownInterval);
	// 						otpGenerated.otp = generateOTP();
	// 						return 0;
	// 					}
	// 					return prevCountdown - 1;
	// 				});
	// 			}, 1000);
	// 		}
	// 	} catch (error) {
	// 		toast.dismiss();
	// 		console.error("Error sending OTP:", error);
	// 		toast.error("Failed to send OTP. Please try again.", {
	// 			className: "custom-toast",
	// 			bodyClassName: "custom-toast-container",
	// 			closeButtonClassName: "custom-toast-close-button",
	// 			onClose: () => { },
	// 		});
	// 	}
	// };

	// Format seconds to MM:SS

const handleGenerateOtp = async () => {
		setValue({
			a: "", b: "", c: "", d: "", e: "", f: "",
		});
		otpGenerated.otp = generateOTP();

		try {
			const response = await fetch(`${api_base_url}/send`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ ...data, otp: otpGenerated.otp }),
			});
			
			toast.dismiss();
			if (response.ok) {
				toast.success("OTP successfully sent to ********55", {
					className: "custom-toast",
					// ... toast config
				});
				startCountdown(60); // ← Use single function
			}
		} catch (error) {
			toast.dismiss();
			console.error("Error sending OTP:", error);
			toast.error("Failed to send OTP. Please try again.", {
				// ... toast config
			});
		}
	};

	const formatTime = (seconds) => {
		const minutes = Math.floor(seconds / 60);
		const remainingSeconds = seconds % 60;
		return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
	};


	const [value, setValue] = useState({
		a: "",
		b: "",
		c: "",
		d: "",
		e: "",
		f: "",
	});

	const aRef = useRef(null);
	const bRef = useRef(null);
	const cRef = useRef(null);
	const dRef = useRef(null);
	const eRef = useRef(null);
	const fRef = useRef(null);
	const verifyRef = useRef(null);

	const handleChange = (event, field, nextRef) => {
		const inputValue = event.target.value;

		if (/^\d?$/.test(inputValue)) {
			setValue((prev) => ({
				...prev,
				[field]: inputValue,
			}));

			if (nextRef && inputValue !== "") {
				nextRef.current.focus();
			}
		}
	};

	// handle backspace and enter
	const handleKeyown = (e, field, prevRef, verifyRef) => {
		if (e.key === "Backspace" && !value[field] && prevRef) {
			prevRef.current.focus();
		} else if (e.key === "Enter" && verifyRef) {
			verifyRef.current.focus();
		}
	};

	// handle paste event (fill all inputs if user pastes OTP)
	const handlePaste = (e) => {
		const pasteData = e.clipboardData.getData("text").trim();
		if (/^\d{6}$/.test(pasteData)) {
			const chars = pasteData.split("");
			setValue({
				a: chars[0],
				b: chars[1],
				c: chars[2],
				d: chars[3],
				e: chars[4],
				f: chars[5],
			});
			fRef.current.focus();
		}
	};

	const otp = Object.values(value).join("");

	// const handleVerify = async () => {
	// 	toast.dismiss();
	// 	const currentDate = new Date().toISOString();
	// 	if (otp == otpGenerated.otp) {
	// 		try {
	// 			setLoading(true);
	// 			const response = await fetch(
	// 				`${api_base_url}/userRegistration/${currentDate}`,
	// 				{
	// 					method: "POST",
	// 					headers: {
	// 						"Content-Type": "application/json",
	// 					},
	// 					body: JSON.stringify(data),
	// 				}
	// 			);

	// 			if (!response.ok) {
	// 				throw new Error("Error submitting data");
	// 			}

	// 			localStorage.removeItem("signupRedirectData");
	// 			localStorage.removeItem("signupTrigger");
	// 			localStorage.removeItem("valid");

	// 			toast.success(`Successfully created ${data.companyName}`, {
	// 				className: "custom-toast",
	// 				bodyClassName: "custom-toast-container",
	// 				closeButtonClassName: "custom-toast-close-button",
	// 				onClose: () => { },
	// 			});

	// 			navigate("/", {
	// 				state: {
	// 					companyName: data.companyName,
	// 				},
	// 			});
	// 		} catch (error) {
	// 			setLoading(false);
	// 			toast.info(
	// 				`Company all ready exist!`,
	// 				{
	// 					className: "custom-toast-error",
	// 					bodyClassName: "custom-toast-error-container",
	// 					closeButtonClassName: "custom-toast-error-close-button",
	// 				}
	// 			);

	// 			console.error("Error submitting data:", error);
	// 		} finally {
	// 			setLoading(false);
	// 		}
	// 	} else {
	// 		toast.error("Otp verification failed!", {
	// 			className: "custom-toast-error",
	// 			bodyClassName: "custom-toast-error-container",
	// 			closeButtonClassName: "custom-toast-error-close-button",
	// 			onClose: () => { },
	// 		});
	// 	}
	// };


	const handleVerify = async () => {
    toast.dismiss();
    const currentDate = new Date().toISOString().split('T')[0]; // Get only date part
    
    console.log("Sending data:", data); // Debug log
    console.log("Current date:", currentDate); // Debug log
    
    if (otp == otpGenerated.otp) {
        try {
            setLoading(true);
            
            const response = await fetch(
                `${api_base_url}/api/auth/register`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(data),
                }
            );

            console.log("Response status:", response.status); // Debug log
            
            const responseData = await response.json(); // Try to parse JSON
            console.log("Response data:", responseData); // Debug log
            
            if (!response.ok) {
                throw new Error(responseData.message || "Error submitting data");
            }

            localStorage.removeItem("signupRedirectData");
            localStorage.removeItem("signupTrigger");
            localStorage.removeItem("valid");
            localStorage.removeItem("Code");
            localStorage.removeItem("DB");
            localStorage.removeItem("Name");
            localStorage.removeItem("userType");
            localStorage.removeItem("USER");
            localStorage.removeItem("UI");
            localStorage.removeItem("userRights");
            localStorage.removeItem("imgCode");
            localStorage.removeItem("Company");
            localStorage.removeItem("token");
            if (typeof window !== "undefined" && 'caches' in window) {
                try {
                    const cache = await caches.open('customer-code');
                    await cache.delete('/Sherdine');
                } catch (err) {
                    console.error("Error clearing signup cache:", err);
                }
            }
            localStorage.setItem("signupSuccess", data.companyName);
            window.location.href = "/";
        } catch (error) {
            setLoading(false);
            console.error("Registration error:", error);
            
            toast.error(
                error.message || "Registration failed. Please try again.",
                {
                    className: "custom-toast-error",
                    bodyClassName: "custom-toast-error-container",
                    closeButtonClassName: "custom-toast-error-close-button",
                }
            );
        } finally {
            setLoading(false);
        }
    } else {
        toast.error("OTP verification failed!", {
            className: "custom-toast-error",
            bodyClassName: "custom-toast-error-container",
            closeButtonClassName: "custom-toast-error-close-button",
            onClose: () => { },
        });
    }
};

	return (
		<div className="w-screen h-screen flex justify-center items-center overflow-hidden zero:p-8 sm:p-12 font-josefin relative">
			{loading && (
				<div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
					<div className="bg-white px-6 py-8 rounded-lg shadow-xl text-center flex flex-col items-center justify-center gap-3 z-50">
						<div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-[#0008B4]"></div>
						<div className="text-lg font-semibold text-[#0008B4] px-4">
							Creating database and registering company, please wait...
						</div>
					</div>
				</div>
			)}

			<div className="w-full flex justify-center items-end h-full md:p-10 gap-5">
				<div className="zero:max-w-full sm:w-1/2 h-full flex flex-col gap-3 sm:justify-center items-start">
					<div className="min-w-0 max-w-full flex flex-col h-full gap-3">
						<div className="w-full h-max flex items-center justify-left gap-1">
							<img className="w-[1rem]" src={SS} alt="" />
							<span
								className="text-2xl font-semibold text-[#0008B4]"
								style={{ fontFamily: "Times New Roman" }}
							>
								SherDine
							</span>
						</div>
						<div className="sm:hidden w-full h-max flex justify-end items-end">
							<img className="w-full" src={Authsign} alt="" />
						</div>
						<div className="w-full h-full flex flex-col justify-start sm:justify-end items-center gap-3">
							<div className="w-full h-max flex flex-col justify-start items-baseline">
								<span className="Signup_Contents_InfoDiv_Title_Head">
									Enter the code
								</span>
								<span className="AuthSign_Contents_InfoDiv_Title_smallLogin">
									Enter the code we sent to your phone number{" "}
									<span className="AuthSignSpan">********55</span>
								</span>
							</div>
							<div className="w-full h-max">

								<div
									className="AuthSign_OTP_Code"
									onPaste={handlePaste} // enable copy-paste
								>
									<input
										type="text"
										value={value.a}
										onChange={(e) => handleChange(e, "a", bRef)}
										ref={aRef}
										maxLength={1}
										onKeyDown={(e) => handleKeyown(e, "a", null)}
									/>
									<input
										type="text"
										value={value.b}
										onChange={(e) => handleChange(e, "b", cRef)}
										ref={bRef}
										maxLength={1}
										onKeyDown={(e) => handleKeyown(e, "b", aRef)}
									/>
									<input
										type="text"
										value={value.c}
										onChange={(e) => handleChange(e, "c", dRef)}
										ref={cRef}
										maxLength={1}
										onKeyDown={(e) => handleKeyown(e, "c", bRef)}
									/>
									<input
										type="text"
										value={value.d}
										onChange={(e) => handleChange(e, "d", eRef)}
										ref={dRef}
										maxLength={1}
										onKeyDown={(e) => handleKeyown(e, "d", cRef)}
									/>
									<input
										type="text"
										value={value.e}
										onChange={(e) => handleChange(e, "e", fRef)}
										ref={eRef}
										maxLength={1}
										onKeyDown={(e) => handleKeyown(e, "e", dRef)}
									/>
									<input
										type="text"
										value={value.f}
										onChange={(e) => handleChange(e, "f")}
										ref={fRef}
										maxLength={1}
										onKeyDown={(e) => handleKeyown(e, "f", eRef, verifyRef)}
									/>
								</div>
							</div>
							<div className="w-full h-max flex flex-col gap-3">
								<button
									className="w-[23rem] max-w-full bg-[#0008B4] rounded-[.313rem] p-2 text-[#fff] cursor-pointer"
									onClick={handleVerify}
									ref={verifyRef}
								>
									Verify
								</button>
								{countdown === 0 && (
									<button
										className="w-[23rem] max-w-full bg-[#666] rounded-[.313rem] p-2 text-[#fff] cursor-pointer"
										onClick={handleGenerateOtp}
									>
										Resend OTP
									</button>
								)}
							</div>
							{countdown > 1 && data.otp ? (
								<div className="w-[23rem] max-w-full bg-transparent p-2 text-[#fff]">
									<button className="ResendBtn">
										Resend OTP in  {formatTime(countdown)}s
									</button>
								</div>
							) : (
								""
							)}
						</div>
					</div>
				</div>
				<div className="w-1/2 h-full hidden sm:flex justify-end items-end">
					<img className="w-full min-h-0 max-h-full" src={Authsign} alt="" />
				</div>
			</div>
		</div>
	);
}

export default AuthSign;
